import type { Product } from "../types";
import { ProductGlyph } from "./ProductGlyph";
import { ProductInterface } from "./ProductInterface";
import { StatusPill } from "./StatusPill";

interface ProductSummaryCardProps {
  product: Product;
  onEnter: (product: Product) => void;
}

export function ProductSummaryCard({ product, onEnter }: ProductSummaryCardProps) {
  return (
    <article
      id={`product-${product.id}`}
      className={`summary-card summary-card--${product.id}`}
    >
      <div className="summary-card__top">
        <div>
          <span className="summary-product-icon">
            <ProductGlyph type={product.id} theme="light" />
          </span>
          <span className="card-eyebrow">
            {product.name} · {product.eyebrow}
          </span>
        </div>
        <StatusPill product={product} />
      </div>
      <h3>{product.title}</h3>
      <p>{product.description}</p>
      <div className="capability-row">
        {product.capabilities.map((item) => (
          <span key={item}>{item}</span>
        ))}
      </div>
      <ProductInterface type={product.id} />
      {product.action ? (
        <button
          className="text-action"
          type="button"
          onClick={() => onEnter(product)}
        >
          {product.action}
          <span>→</span>
        </button>
      ) : null}
    </article>
  );
}
